import { useState } from "react";

const FAQS = [
  {
    q: "为什么网上关于这起事件的说法差这么多？",
    a: "核心原因是信息差。不同账号掌握的材料、立场和时间点各不相同：有人拿到早期不完整信息，有人转发时加入了自我发挥，还有人只挑最抓眼球的部分传播。说法自然五花八门。想要对齐，唯一办法是回到原始出处、按时间线逐条核对。",
  },
  {
    q: "没有权威通报时，该怎么判断谁说得对？",
    a: "可以先按三问过滤：这条信息出自谁之口？它有没有可核对的原始出处？有没有独立信源能互相印证？当多个互不知情的信源指向同一事实时，可信度会明显提高；单点孤证或全凭转述的说法，建议先存疑，不要急着采信。",
  },
  {
    q: "看到‘实锤’两个字就一定是真的吗？",
    a: "不一定。‘实锤’是网民对证据强度的主观评价，不同人标准不同。真正的强证据应满足两点：有清晰的原始出处，并且内容可以被第三方交叉验证。把‘实锤’当结论标签，不如把它当作‘需要继续核验’的提示。",
  },
  {
    q: "事件出现反转，说明之前的版本是假的吗？",
    a: "反转通常说明事件有了新进展，比如新的证据或当事人的回应推翻了部分旧说法，而不是说整件事都是假的。更准确的表述是：随着信息补全，我们对事件的认识在修正。所以越晚下的结论，往往越接近真相。",
  },
  {
    q: "本站整理的‘来龙去脉与时间线’是最终定论吗？",
    a: "不是。本站重点提供的是梳理争议的通用框架与核验方法，帮助读者形成自己的判断框架。任何事件的具体节点都可能因新证据而更新，最终结论请以可溯源的一手信源与权威通报为准。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="flex items-center justify-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
            <i className="ri-question-answer-line w-4 h-4 flex items-center justify-center" />
            06 · 常见问题
          </p>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            你可能还想问
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-loose">
            围绕事件信息的常见疑问，我们尽量用大白话讲清楚。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                    {item.q}
                  </h3>
                  <span
                    className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full border transition-colors ${
                      isOpen
                        ? "bg-primary-500 border-primary-500 text-background-50"
                        : "border-background-300 text-foreground-700"
                    }`}
                  >
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} w-4 h-4 flex items-center justify-center`}
                    />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm text-foreground-700 leading-relaxed">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}